module.exports = __webpack_public_path__ + "static/img/home-page-add.2bb8b81a.svg";